export const SignUpHeaderFreeDemo = () => {
  return (
    <div className="sign-up-header">
      <h2 className="sign-up-header__title">Create a Free Trial Account</h2>
      <p className="sign-up-header__subtitle">
        If you already have an account, please return home or click log in button
      </p>
    </div>
  );
};

export const SignUpHeaderUserRegistration = () => {
  return (
    <div style={{ textAlign: 'center', padding: '0 1rem' }}>
      <h2 style={{ margin: '0 0 0.5rem 0' }}>Create Your User Account</h2>
      <p style={{ margin: 0 }}>Welcome to TotalEquipIQ!</p>
    </div>
  );
};

export const SignUpHeaderSuperAdminRegistration = () => {
  return (
    <div style={{ textAlign: 'center', padding: '0 1rem' }}>
      <h2 style={{ margin: '0 0 0.5rem 0' }}>Create Your Company Owner Account</h2>
      <p style={{ margin: 0 }}>Welcome to TotalEquipIQ!</p>
    </div>
  );
};

export const SignUpHeaderBusinessAdminRegistration = () => {
  return (
    <div style={{ textAlign: 'center', padding: '0 1rem' }}>
      <h2 style={{ margin: '0 0 0.5rem 0' }}>Create Your Platform Admin Account</h2>
      <p style={{ margin: 0 }}>Welcome to the TotalEquipIQ Admin Platform!</p>
    </div>
  );
};